const TimesheetStatusConstants = {
    MISSING: -1,
    DRAFT: 0,
    INPROGRESS: 1,
    COMPLETED: 2,
    INVOICED: 3,
}

export default TimesheetStatusConstants